(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["key-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ingredient-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      var item = btn.closest('.key-ingredients__item');
      var expanded = item ? item.nextElementSibling : null;

      btn.setAttribute('aria-expanded', !isExpanded);

      if (expanded && expanded.classList.contains('key-ingredients__expanded')) {
        expanded.setAttribute('aria-hidden', isExpanded);
      }
    });

    // Also allow clicking the whole item row
    var item = btn.closest('.key-ingredients__item');
    if (item) {
      item.addEventListener('click', function() {
        btn.click();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
